import { Fragment, useState } from "react";
//--------------------------------------------------------------------------------------------
import Modal from "src/components/common/modal";
import { myAxios, MyFormData } from "src/components/common/functions";
import { isPositiveQuantityText } from "./inventoryUtils";
//--------------------------------------------------------------------------------------------
export default function AddInventoryModal({ closeIt, onDone, yards, items, setShowLoader }){
    const [yardId, setYardId] = useState(yards[0]?.id || "");
    const [itemMode, setItemMode] = useState(items.length ? "existing" : "new");
    const [itemId, setItemId] = useState(items[0]?.id || "");
    const [itemName, setItemName] = useState("");
    const [unit, setUnit] = useState("");
    const [lowStockQty, setLowStockQty] = useState("");
    const [quantity, setQuantity] = useState("");
    const [poNumber, setPoNumber] = useState("");
    const [notes, setNotes] = useState("");
    const handleSubmit = async() => {
        if(!yards.length){ window.alert("Create a yard before adding inventory."); return; }
        if(!yardId){ window.alert("Please select a yard."); return; }
        if(!quantity || !isPositiveQuantityText(quantity)){ window.alert("Please enter a quantity greater than 0."); return; }
        let finalItemId = itemId;
        setShowLoader(true);
        if(itemMode === "new"){
            if(!itemName.trim()){
                setShowLoader(false);
                window.alert("Please enter the new item name.");
                return;
            }
            if(lowStockQty && !isFinite(Number(lowStockQty))){
                setShowLoader(false);
                window.alert("Low stock quantity must be a valid number.");
                return;
            }
            const itemForm = new MyFormData();
            itemForm.append("name", itemName);
            itemForm.append("unit", unit);
            itemForm.append("lowStockQty", lowStockQty);
            const itemRes = await myAxios("inventory/createItem.php", itemForm);
            if(!itemRes){ setShowLoader(false); return; }
            finalItemId = itemRes.data.item?.id;
        }
        if(!finalItemId){
            setShowLoader(false);
            window.alert("Please select or create an item.");
            return;
        }
        const formData = new MyFormData();
        formData.append("yardId", yardId);
        formData.append("itemId", finalItemId);
        formData.append("quantity", quantity);
        formData.append("poNumber", poNumber);
        formData.append("notes", notes);
        const res = await myAxios("inventory/receiveStock.php", formData);
        setShowLoader(false);
        if(!res) return;
        onDone();
        closeIt();
    };
    return <Modal title = "Add Inventory" closeIt = {closeIt} width = "46rem" handleFormSubmit = {handleSubmit} actionKey = "Add Inventory" formFormat = "">
        <div className = "inventoryModalBody inventoryFormGrid">
            <div>
                <label className = "font-weight-bold">Yard</label>
                <select className = "form-control" value = {yardId} onChange = {e => setYardId(e.currentTarget.value)}>
                    <option value = "">Select Yard</option>
                    {yards.map(yard => <option key = {yard.id} value = {yard.id}>{yard.name}</option>)}
                </select>
            </div>
            <div>
                <label className = "font-weight-bold">Item Option</label>
                <select className = "form-control" value = {itemMode} onChange = {e => setItemMode(e.currentTarget.value)}>
                    <option value = "existing" disabled = {!items.length}>Use Existing Item</option>
                    <option value = "new">Create New Item</option>
                </select>
            </div>
            {itemMode === "existing"?
                <div>
                    <label className = "font-weight-bold">Inventory Item</label>
                    <select className = "form-control" value = {itemId} onChange = {e => setItemId(e.currentTarget.value)}>
                        <option value = "">Select Item</option>
                        {items.map(item => <option key = {item.id} value = {item.id}>{item.name}{item.unit?` (${item.unit})`:""}</option>)}
                    </select>
                </div>:
                <Fragment>
                    <div>
                        <label className = "font-weight-bold">New Item Name</label>
                        <input className = "form-control" value = {itemName} onChange = {e => setItemName(e.currentTarget.value)} placeholder = "Example: Paint Cans"/>
                    </div>
                    <div>
                        <label className = "font-weight-bold">Unit</label>
                        <input className = "form-control" value = {unit} onChange = {e => setUnit(e.currentTarget.value)} placeholder = "Example: cans, each, boxes"/>
                    </div>
                    <div>
                        <label className = "font-weight-bold">Low Stock Qty</label>
                        <input className = "form-control" type = "number" min = "0" step = "any" value = {lowStockQty} onChange = {e => setLowStockQty(e.currentTarget.value)} placeholder = "Optional"/>
                    </div>
                </Fragment>}
            <div>
                <label className = "font-weight-bold">Quantity</label>
                <input className = "form-control" type = "number" min = "0.01" step = "any" value = {quantity} onChange = {e => setQuantity(e.currentTarget.value)} />
            </div>
            <div>
                <label className = "font-weight-bold">PO Number</label>
                <input className = "form-control" value = {poNumber} onChange = {e => setPoNumber(e.currentTarget.value)} placeholder = "Optional"/>
            </div>
            <div className = "inventoryFormFull">
                <label className = "font-weight-bold">Notes</label>
                <textarea className = "form-control" value = {notes} onChange = {e => setNotes(e.currentTarget.value)} rows = {3} placeholder = "Optional"/>
            </div>
        </div>
    </Modal>;
}
